import { configureStore } from "@reduxjs/toolkit";
import showAuthSlice from "./slices/showAuthSlice";
import liveDetailSlice from "./slices/liveDetailSlice";
import feedSlice from "./slices/feedSlice";

const appStore = configureStore({
  reducer: {
    showAuth: showAuthSlice,
    feeds: feedSlice,
    liveDetail: liveDetailSlice,
  },
});

export default appStore;
